import React from 'react'

const CancelledBooking = () => {
  return (
    <div>CancelledBooking</div>
  )
}

export default CancelledBooking